import React from 'react';
import { Link } from 'react-router-dom';
import './BlogCard.css';

const BlogCard = ({ blog }) => {
  return (
    <Link to={blog.link} className="blog-card">
      <img src={blog.imageUrl} alt={blog.title} className="blog-image" />
      <div className="blog-content">
        <p className="blog-date">{blog.date}</p>
        <h3 className="blog-title" dangerouslySetInnerHTML={{ __html: blog.title }} />
        <p className="blog-description">{blog.description}</p>
        <span className="d-flex align-items-center gap-2">
          <span className="link-blog-page">Lire l'article</span>
          <span className="arrow-blog">❯</span>
        </span>
      </div>
    </Link>
  );
};

export default BlogCard;
